import 'bootstrap/js/dist/carousel';
import $ from 'jquery';
import '../../src/membership_with_landing_pages_styles/pro_membership_landing_page_global_styles.scss';

document.addEventListener('DOMContentLoaded', () => {
  // On expired url scrolls to white-box container,
  // which contains expired error message
  if (window.location.pathname === '/register/PRO/expired'){
    $('html, body').animate(
      {
        scrollTop: $('.white-box').offset().top-25,
      },
      1500
    );
  }

  // Function for smooth scrolling
  $('a.anchor').on('click', function () {
    var sectionTo = $(this).attr('href');
    $('html, body').animate(
      {
        scrollTop: $(sectionTo).offset().top,
      },
      1500
    );
  });
});
